<template>
  <div class="heatmap-box">
    <div class="country-info">
      <AbPlayerImg
        v-if="playerInfo.playerId"
        :playerImg="playerInfo.profilePicture"
        :playerNum="playerInfo.shirtNumber * 1"
        :playerName="playerInfo.playerName"
        :countryImg="objectInfo.teamLogo"
        :countryName="objectInfo.teamName"
        :age="playerInfo.age"
        :clubName="playerInfo.clubName"
        :height="playerInfo.height"
        :width="'100%'"
      />
      <template v-else>
        <div class="country-logo">
          <img :src="objectInfo.teamLogo" alt="" />
        </div>
        <div class="country-name">
          {{ objectInfo.teamName }}
        </div>
      </template>
    </div>
    <div class="head_map" :class="isAutoExportPng ? 'autoExportPng' : ''">
      <div class="horizontal_box">
        <div :class="isBorder ? 'echartsBorder' : ''" class="echartsBg">
          <div
            id="singleBall"
            ref="singleBall"
            :style="{ height: Math.floor(singleBallWidth / 1.5) + 'px' }"
            @click.stop="downLoad($refs.singleBall, true)"
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import HMap from 'heatmap.js'
import datas from './heatmap.json'
import cup_base_data_mixin from '@mixins/cup_base_data'
import canvasToImage_base64_data_mixin from '@mixins/canvasToImage_base64_data'
import AbPlayerImg from '@components/compreSportsMeet/html/components/PlayerImg.vue'
export default {
  name: 'head_map',
  mixins: [canvasToImage_base64_data_mixin, cup_base_data_mixin],
  components: { AbPlayerImg },
  props: {
    datas: {
      // 必传参数，球员的所有信息放到一个对象里
      type: Object,
      default: () => ({
        objectInfo: [],
        data: {
          dataList: [],
        },
        statisticsModels: [],
      }),
    },
    isBorder: {
      //演播室要球场和边界区域一起的，所以不要边，比例是2000/1340=1.49，约等于1.5
      type: Boolean,
      default: false,
    },
    // echartData: {
    //   default: function() {
    //     return {
    //       title: "",
    //       dimensions: [],
    //       resultData: [],
    //       itemList: [],
    //       teamInfos: [],
    //       objectInfo: [
    //         {
    //           objectLogo: "",
    //           objectName: ""
    //         },
    //       ],
    //       dimensionNames: [],
    //       eventData:{
    //       }
    //     };
    //   }
    // },
    isAutoExportPng: {
      //是否导出图片页面使用
      type: Boolean,
      default: false,
    },
    heatWeight: {
      // 热力图权重系数
      type: Number,
      default: 0.45,
    },
  },
  data() {
    return {
      teamNum: true, // true两队  false 1队
      dataArr: [],
      singleBallWidth: 0,
      isDb: true, // 双击禁止
    }
  },
  computed: {
    objectInfo() {
      return this.datas?.objectInfo?.[0] || {}
    },
    playerInfo() {
      return this.objectInfo?.playerInfos?.[0] || {}
    },
  },
  created() {
    // this.datas = datas
  },
  mounted() {
    this.$nextTick(() => {
      // this.parentWidth = this.$refs.echartsParent.clientWidth
      // this.parentHeight = this.$refs.echartsParent.clientHeight
      this.singleBallWidth = this.$refs.singleBall.clientWidth
      this.singleBallHeight = this.$refs.singleBall.clientHeight
      this.initMap()
      console.debug('this.parentWidth:', this.parentWidth)
    })
  },
  watch: {
    datas(val) {
      this.singleBallWidth = this.$refs.singleBall.clientWidth
      this.singleBallHeight = this.$refs.singleBall.clientHeight
      this.$nextTick(() => {
        this.createMap(this.heatmapInstance)
      })
    },
  },
  methods: {
    initMap() {
      this.$nextTick(() => {
        this.heatmapInstance = HMap.create({
          container: this.$refs.singleBall,
          // backgroundColor: 'rgba(255,255,255,0.3)', // '#121212'    'rgba(0,102,256,0.2)'
          // radius: this.isAutoExportPng ? 66 : 20, // [0,+∞)
          radius: Math.round(this.singleBallWidth / 15.4),
        })

        this.createMap()
      })
    },
    initData(w, h, data, column) {
      var dataArr = []
      if (!data) {
        this.dataArr = dataArr
        return
      }
      if (column) {
        data.forEach((item, index) => {
          // console.debug('item.r:', item)
          dataArr[index] = {
            x: parseInt((item.x / 100) * w),
            y: -parseInt((item.y / 100) * h) + h,
            value: item.r * 1 > 0.6 ? 0.6 : this.heatWeight,
          }
        })
      } else {
        data.forEach((item, index) => {
          // console.debug('item.r:', item, item.r * 1)
          dataArr[index] = {
            x: parseInt((item.x / 100) * w),
            y: -parseInt((item.y / 100) * h) + h,
            // y: parseInt(((100 - item.y) / 100) * h),
            value: item.r * 1 > 0.6 ? 0.6 : this.heatWeight,
          }
        })
      }
      // console.debug('dataArr:', dataArr[0], w, h)
      this.dataArr = dataArr
    },
    calculateHeatMax(data) {
      const radius = Math.round(this.singleBallWidth / 15.4)
      const grid = new Map()
      for (const item of data) {
        const gx = Math.floor(item.x / radius)
        const gy = Math.floor(item.y / radius)
        const key = `${gx}_${gy}`
        grid.set(key, (grid.get(key) || 0) + item.value)
      }
      const values = [...grid.values()].sort((a, b) => a - b)
      const index = Math.floor(values.length * 0.5)
      return Math.max(1, values[index])
    },
    createMap() {
      // 单场图配置
      let points = []
      // let max = 6
      this.singleBallWidth = this.$refs.singleBall.clientWidth
      // let height = Math.floor(this.singleBallWidth / 1.5)
      this.singleBallHeight = this.$refs.singleBall.clientHeight
      this.initData(
        this.singleBallWidth,
        this.singleBallHeight,
        this.datas.data.dataList
      )
      const max = this.calculateHeatMax(this.dataArr)
      let data = {
        max: max,
        data: this.dataArr,
      }
      //因为data是一组数据,web切图报价所以直接setData
      this.heatmapInstance.setData(data)
      if (this.isAutoExportPng) {
        setTimeout(() => {
          this.upLoad(this.$refs.singleBall, true, 'uploadData')
        }, 500)
      }
    },
    // downLoad(e) {
    //   if (!this.isAutoExportPng) {
    //     return
    //   }
    //   if (!this.isDb) {
    //     return
    //   }
    //   this.isDb = false
    //   this.$nextTick(() => {
    //     const el = e.target
    //     console.debug(el)
    //     this.toImage.getOptions({
    //       el: el,
    //     })
    //   })
    //   setTimeout(() => {
    //     this.isDb = true
    //   }, 500)
    // },
  },
}
</script>
<style lang="scss" scoped>
.heatmap-box {
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 2vw;
  padding: 2% 3%;
  .country-info {
    flex: 1;
    .country-logo {
      width: 100%;
      position: relative;
      width: 50%;
      margin: 0 auto;
      margin-bottom: 1.388vw;
      &::before {
        content: ' ';
        position: absolute;
        left: 0;
        top: 0;
        z-index: 2;
        width: 100%;
        height: 100%;
        border: 1px solid var(--mixtmt_greyColor5);
      }
      img {
        width: 100%;
      }
    }
    .country-name {
      text-align: center;
      color: var(--mixtmt_greyColor_main);
    }
  }
}
.head_map {
  color: #fff;
  width: 70%; //59%
  &.autoExportPng {
    .horizontal_box {
      border: 0;
      background: transparent;
      border-radius: 0;
    }
  }
  .horizontal_box {
    border: 0.416vw solid var(--mixtmt_echarts_footBallPlaygroundColor);
    background: var(--mixtmt_echarts_footBallPlaygroundColor);
    border-radius: 0.694vw;
  }
  .echartsBg {
    background-color: var(--mixtmt_echarts_footBallPlaygroundBgColor);
  }
}
.echartsBorder {
  border: 0.416vw solid #eaedf1;
  background: #eaedf1;
  border-radius: 0.694vw;
}
#singleBall {
  flex-shrink: 0;
  width: 100%;
  height: 100%;
  background-image: var(--mixtmt_ball_bg);
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-position: center;
  font-size: 0;
  // border:6px solid #EAEDF1;
  // border-radius: 14px;
  // box-sizing: content-box;
}
#singleBall {
  width: 100%;
  height: 100%;
  transform: rotateX(0deg);
}

/* #team1,
#team2 {
  position: absolute;
  transform: rotateX(0deg) rotateY(0deg) rotateZ(-90deg);
} */
</style>
